// 实名认证开关
export enum EVerifyUserSwitch {
  able = "able",
  disabled = "disable",
}
// 邀请码开关
export enum EInvitationSwitch {
  required = "required", // 必填
  optional = "optional", // 选填
  hidden = "hidden", // 隐藏
}

// 登录即注册开关
export enum ELoginRegisterSwitch {
  able = "able",
  disabled = "disable",
}
